import { css } from "styled-components";

function hexToRgb(hex: string): string {
	const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!match) {
		throw Error("Expected hexadecimal color format, received " + hex);
	}

	return `rgb(${[1, 2, 3].map((i) => parseInt(match[i], 16)).join(",")})`;
}

export function alpha(hex: string, alpha: number): string {
	return hexToRgb(hex).replace("rgb", "rgba").replace(")", `,${alpha})`);
}

export const mobile = "(max-width: 900px)";
export const smallMobile = "(max-width: 360px)";
export const desktop = "(min-width: 900px)";

export const mobileOnly = (display: "block" | "flex" = "flex"): ReturnType<typeof css> => css`
	display: none;
	@media ${mobile} {
		display: ${display};
	}
`;

export const gap = (size: string | number, direction: "row" | "column" = "column"): ReturnType<typeof css> => css`
	> :not(:last-child) {
		${
			direction === "row"
				? `margin-right: ${typeof size === "number" ? size + "px" : size}`
				: `margin-bottom: ${typeof size === "number" ? size + "px" : size}`
		};
	}
`;

export const DEFAULT_WIDTH = 1440;
export const DEFAULT_HEIGHT = 900;
export function scaledPx(pixels: number): string {
	return `${(pixels / DEFAULT_WIDTH) * 100}vw`;
}

export const TOP_BAR_OFFSET = 87;
export const TOP_BAR_OFFSET_MOBILE = 90;
